import React, { useState, useEffect } from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Layout from '../components/Layout/Layout';
import apiService from '../services/api';

const useStyles = makeStyles((theme) => ({
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 300,
  },
  catalogCard: {
    height: '100%',
  },
  strategyChip: {
    margin: theme.spacing(0.5),
  },
}));

function Catalogs() {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [catalogs, setCatalogs] = useState([]);
  const [strategies, setStrategies] = useState([]);
  const [baskets, setBaskets] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [catalogData, strategyData, basketData] = await Promise.all([
        apiService.getCatalogs(),
        apiService.getStrategies(),
        apiService.getBaskets(),
      ]);
      setCatalogs(catalogData);
      setStrategies(strategyData);
      setBaskets(basketData);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getStrategiesForCatalog = (catalogId) => {
    return strategies.filter((s) => s.catalog_id === catalogId);
  };

  const getBasketsForStrategy = (strategyId) => {
    return baskets.filter((b) => b.strategy_id === strategyId);
  };

  if (loading) {
    return (
      <Layout title="Catalogs & Strategies" onRefresh={fetchData}>
        <Box className={classes.loadingContainer}>
          <CircularProgress />
        </Box>
      </Layout>
    );
  }

  return (
    <Layout title="Catalogs & Strategies" onRefresh={fetchData}>
      <Grid container spacing={3}>
        {catalogs.map((catalog) => (
          <Grid item xs={12} key={catalog.id}>
            <Card className={classes.catalogCard}>
              <CardContent>
                <Typography variant="h6">{catalog.name}</Typography>
                <Typography color="textSecondary" gutterBottom>
                  {catalog.description || 'No description'}
                </Typography>

                {getStrategiesForCatalog(catalog.id).map((strategy) => (
                  <Accordion key={strategy.id}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Box display="flex" alignItems="center" width="100%">
                        <Typography>{strategy.name}</Typography>
                        <Chip
                          size="small"
                          label={strategy.strategy_view === 1 ? 'LONG' : strategy.strategy_view === -1 ? 'SHORT' : 'NEUTRAL'}
                          style={{ marginLeft: 16 }}
                        />
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Description</TableCell>
                            <TableCell>Lot Size</TableCell>
                            <TableCell>Symbol</TableCell>
                            <TableCell>Instrument</TableCell>
                            <TableCell>Side</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {getBasketsForStrategy(strategy.id).map((basket) => (
                            <TableRow key={basket.id}>
                              <TableCell>{basket.description}</TableCell>
                              <TableCell>{basket.lot_size}</TableCell>
                              <TableCell>{basket.symbol}</TableCell>
                              <TableCell>{basket.instrument_type}</TableCell>
                              <TableCell>{basket.transaction_side}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Layout>
  );
}

export default Catalogs;
